import React from 'react';

import { Box, Tooltip, Typography } from '@mui/material';
import { InfoIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import {
  taskCardBodyStyles,
  taskCardHeaderStyles,
  taskCardStyles,
  taskInfoButtonWrapperStyles,
  taskInfoIconWrapperStyles,
  taskInfoTooltipSlotProps,
} from '../../AddConditionsForm.styles';

const TaskCard = ({ taskNumber, taskTypeName, headerAction = null, children }) => (
  <Box sx={taskCardStyles}>
    <Box sx={taskCardHeaderStyles}>
      <Typography variant="medium14">Task {taskNumber}</Typography>
      {headerAction}
    </Box>
    <Box sx={taskCardBodyStyles}>
      {taskTypeName && (
        <Box sx={taskInfoButtonWrapperStyles}>
          <Tooltip
            placement="top"
            slotProps={taskInfoTooltipSlotProps}
            title={`Task type: ${taskTypeName}`}
          >
            <Box component="span" sx={taskInfoIconWrapperStyles}>
              <InfoIcon size={IconSize[16]} />
            </Box>
          </Tooltip>
        </Box>
      )}
      {children}
    </Box>
  </Box>
);

TaskCard.propTypes = {
  taskNumber: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  taskTypeName: PropTypes.string,
  headerAction: PropTypes.node,
};

export default TaskCard;
